module.exports = __webpack_public_path__ + "assets/img/202111-2.01314572.png";